import { useState } from 'react';
import { LiaClipboardListSolid } from 'react-icons/lia';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Calendar } from '../../../assets/collectcard/calendar.svg';
import { ReactComponent as Line } from '../../../assets/collectcard/line.svg';
import { ReactComponent as Milk } from '../../../assets/collectcard/milk.svg';
import { ReactComponent as Vehicle } from '../../../assets/collectcard/vehicle.svg';
import { ReactComponent as Wagoner } from '../../../assets/collectcard/wagoner.svg';
import { useCollectContext } from '../../../context/ProviderPage/Coleta';
import { usePageContext } from '../../../context/usePage';
import { OpenCollect } from '../../../types/OpenCollect';
import { formatDate } from '../../../utils/date/formatDate';
import { Counter } from '../../Contador';
import { OpenCollectCardContainer, CollectMilkInformation } from './styles';

const OpenCollectCard = (collect: OpenCollect) => {
  const {
    DFIDCOLETA,
    DFORDEMCOLETA,
    DFNOMECARRETEIRO,
    DFPLACAVEICULO,
    DFNOMELINHA,
    DFDATAPROGRAMADA,
    DFDATACOLETA,
    EXIBICAO: EXIBICAOTANQUE,
  } = collect;

  const [activeMeter, setActiveMeter] = useState(false);

  const collectMetrics = (data: OpenCollect) => {
    const { DFCAPACIDADETOTALVEICULO, DFTOTALARMAZENADO } = data;
    const totalArmazenado = Number(DFTOTALARMAZENADO) || 0;
    const capacidadeVeiculo = Number(DFCAPACIDADETOTALVEICULO) || 0;

    const porcentagem =
      capacidadeVeiculo > 0 ? (totalArmazenado / capacidadeVeiculo) * 100 : 0;

    const meter = porcentagem > 100 ? 100 : porcentagem;

    return {
      CAPACIDADETOTAL: capacidadeVeiculo,
      TOTALARMAZENADO: totalArmazenado,
      OCUPACAOPORC: porcentagem.toFixed(2),
      DISPONIBILIDADEPORC: (100 - porcentagem).toFixed(2),
      meter,
    };
  };

  const {
    CAPACIDADETOTAL,
    TOTALARMAZENADO,
    DISPONIBILIDADEPORC,
    OCUPACAOPORC,
    meter,
  } = collectMetrics(collect);

  const navigation = useNavigate();
  const { version } = usePageContext();
  const { setCloseCollect, setDischargeCollect } = useCollectContext();

  setTimeout(() => {
    setActiveMeter(true);
  }, 100);

  return (
    <OpenCollectCardContainer>
      <div className="card-title">
        <Wagoner />
        <h1>{DFNOMECARRETEIRO}</h1>
      </div>
      <div className="collect-item-row">
        <div className="item-row-medium-with-border">
          <LiaClipboardListSolid />
          <span>Ordem Coleta: {DFORDEMCOLETA}</span>
        </div>
        <div className="item-row-medium">
          <Vehicle />
          <span>Veículo: {DFPLACAVEICULO}</span>
        </div>
      </div>
      <div className="collect-item-row">
        <div className="item-row">
          <Line />
          <span>Linha: {DFNOMELINHA}</span>
        </div>
      </div>
      <div className="collect-item-row">
        <div className="item-row-medium-with-border">
          <Calendar />
          <span>Programada: {formatDate(DFDATAPROGRAMADA)}</span>
        </div>
        <div className="item-row-medium">
          <Calendar />
          <span>Coleta: {formatDate(DFDATACOLETA)}</span>
        </div>
      </div>
      <CollectMilkInformation {...{ meter, activeMeter }}>
        <div className="milk-title-information ">
          <Milk />
          <span>Quantidade coletada</span>
        </div>
        <div className="box-milk-information">
          <div className="info">
            <span>Ocupação:</span>
            <span>{OCUPACAOPORC}%</span>
          </div>
          <div className="info border">
            <span>Disponibilidade:</span>
            <span>{DISPONIBILIDADEPORC}%</span>
          </div>
          <div className="info">
            <span>Total:</span>
            <span>{EXIBICAOTANQUE}</span>
          </div>
        </div>
        <div className="item-column">
          <div className="item-row">
            <span>
              <b>Coletado: </b>
              <Counter finalNumber={TOTALARMAZENADO} />
            </span>
            <span>
              <b>Total: </b>
              {/* <span>{DFCAPACIDADETOTALVEICULO}</span> */}
              <Counter finalNumber={CAPACIDADETOTAL} />
            </span>
          </div>
          <div className="progress-milk-content">
            <div className="progress-milk-meter" />
          </div>
        </div>
      </CollectMilkInformation>
      <footer className="card-footer">
        <div className="left-buttons">
          <button
            className="visualize"
            onClick={() =>
              navigation(`/coleta/${DFIDCOLETA}/acompanhar${version}`)
            }
          >
            Acompanhar
          </button>
          <button
            className="dicharge-collect"
            onClick={() =>
              setDischargeCollect({
                isOpen: true,
                collect,
                id: DFIDCOLETA,
              })
            }
          >
            Descarregar
          </button>
        </div>
        <button
          className="close-collect"
          onClick={() =>
            setCloseCollect({
              isOpen: true,
              collect,
            })
          }
        >
          Cancelar Coleta
        </button>
      </footer>
    </OpenCollectCardContainer>
  );
};

export { OpenCollectCard };
